<template>
    <v-container class="mt-3">
        <v-card flat class="pa-6">
            <div class="text-h3 font-weight-bold">
                Our Team
            </div>
            <div class="mt-6">
                <p>
                    Unsub is a project of <a href="https://openalex.org">OpenAlex,</a> a nonprofit building tools to help make scholarly research more open, connected, and reusable. We maintain a small full-time team, which helps us stay agile and sustainable. See our <a href="https://openalex.org/team" target="_blank">team page</a> for bios.
                </p>
            </div>
        </v-card>


    </v-container>
</template>

<script>
    export default {
        name: "Team",
        metaInfo() {
            return {
                title: `Team`
            }
        },
    }
</script>

<style scoped>

</style>
